// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__OqQ2P","modal":"Modal_modal__48vWd","slide-down":"Modal_slide-down__4sHMU"};